import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';
import _ from 'lodash';
import { mediumModalStyle } from '../../constants';
import { getDateValue } from '../../utils/date';
import { fetchDocumentChecklist } from '../../actions/additional_actions';
import { withAuth } from '../../actions/';
import { DateFieldFixedDateBelow } from './date_picker_fixed_dateBelow';

 class InfraChecklist extends Component {
//     static PropTypes = {
//         documentCheckList: PropTypes.array.isRequired,
//         permissions: PropTypes.object.isRequired,
//         fetchDocumentChecklist: PropTypes.func.isRequired,
//     }

    constructor(props) {
        super(props);

        this.state = {
            documentCheckList: props.documentCheckList,
            showSavedMsg: false,
            modalVisible: false,
            logsList: [],
            isLoading: false,
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showLog = this.showLog.bind(this);
        this.onDone = this.onDone.bind(this);
        this.handleSelectChangeDd = this.handleSelectChangeDd.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.documentCheckList.length !== 0)
            this.setState({ documentCheckList: nextProps.documentCheckList })
    }

    UNSAFE_componentWillMount() {
        this.props.fetchDocumentChecklist(this.props.projectId);
    }

    handleSelectChange(index, field) {
        return (option) => {
            const value = option ? option.value : null;
            const documentCheckList = this.state.documentCheckList;
            documentCheckList[index][field] = value;

            if ( documentCheckList[index][field] === 'Not applicable')
            {
                documentCheckList[index]['submittedDate'] = null;
                documentCheckList[index]['receivedDate'] = null;
            }

            if (documentCheckList.some(c => c.receivedDate !== null && (c.submittedDate === null || c.submittedDate === '')))        
                 this.setState({ canSubmit: false });
            else 
                 this.setState({ canSubmit: true });

            this.setState({ documentCheckList });
        }
    }

    handleDateChange(index, name) {
        return (date) => {
            const documentCheckList = this.state.documentCheckList;
            documentCheckList[index][name] = date;
            this.setState({ documentCheckList });

            if (documentCheckList.some(c => c.receivedDate !== null && (c.submittedDate === null || c.submittedDate === '')))
                this.setState({ canSubmit: false });
            else
                this.setState({ canSubmit: true });
        }
    }

    handleChange(index, field) {
        return (e) => {
            const documentCheckList = this.state.documentCheckList;
            documentCheckList[index][field] = e.target.value;
            this.setState({ documentCheckList });
        };
    }

    handleSubmit(e) {
        const documentCheckList = this.state.documentCheckList;
        const projectId = this.props.projectId;

        const { roleModules } = this.props.permissions.editPrivileges;

        documentCheckList.forEach(function (item) {
            item.projectId = projectId;
        });

        let method = 'post';
        let url = `projects/${projectId}/documentChecklist`;

        if (documentCheckList.some(c => c.id !== '' && c.id !== 0)) {
            method = 'put';
        }

        if (roleModules !== null && roleModules.includes('Infrastructure checklist'))
            return this.makePutOrPostRequest(documentCheckList, method, url);
    }

    makePutOrPostRequest(documentCheckList, method, url) {
        const { projectId } = this.props;
        documentCheckList.projectId = projectId;

        this.setState({ isLoading: true });

          withAuth(
              { method, url, data: documentCheckList },
              () => {
                  this.props.fetchDocumentChecklist(projectId);
                  this.setState({ showSavedMsg: true });
                  toast.success('Saved Successfully!');
                  this.setState({ isLoading: false });
              },
              this.errorHandler
          )
    }

    showLog(item) {
        this.setState({ modalVisible: true, logsList: item.documentChkList_Log });
    }

    onDone() {
        this.setState({ modalVisible: false });
    }

    renderTable(logsList) {
        return (
            <div className="table-wrap">
                <table>
                    <thead>
                        <tr>
                            <th>Applicable/Not applicable</th>
                            <th>Date Ordered</th>
                            <th>Date Required</th>
                            <th>Date Received/Achieved</th>
                            <th>Comments</th>
                            <th>Created By</th>
                            <th>Created Date</th>
                            <th>Modified By</th>
                            <th>Modified Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {_.orderBy(logsList, ['createdDate'], ['desc']).map(log =>
                            <tr key={log.id}>
                                <td>{log.applicableStatus}</td>
                                <td>{getDateValue(log.submittedDate)}</td>
                                <td>{getDateValue(log.dateRequired)}</td>
                                <td>{getDateValue(log.receivedDate)}</td>
                                <td>{log.comments}</td>
                                <td>{log.createdBy}</td>
                                <td>{getDateValue(log.createdDate)}</td>
                                <td>{log.modifiedBy}</td>
                                <td>{getDateValue(log.modifiedDate)}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    getSelectOptions(values, name) {
        return values.map(value => {
          return {
            label: value[name],
            value: value.id
          }
        });
      }

      handleSelectChangeDd(index, field) {
        return (option) => {
            const value = option ? option.value : null;
            const documentCheckList = this.state.documentCheckList;
            documentCheckList[index][field] = value;

            this.setState({ documentCheckList });
        }
    }

    render() {
        const { documentCheckList } = this.state;
        const logsList = this.state.logsList;
        const { isLoading } = this.state;

        const { roleModules } = this.props.permissions.editPrivileges;
        const canSubmit = roleModules !== null && roleModules.includes('Infrastructure checklist') && !isLoading
        ? true : false;       

        return (
            <div>

                {this.state.modalVisible
                    && <Modal
                        isOpen={this.state.modalVisible}
                        style={mediumModalStyle}
                        contentLabel="Status Log"
                    >
                        <h1>Status Log</h1>

                        <div className="modal-form">
                            <div className="project-detail-comments">
                                <div className="col s12">
                                    {logsList.length
                                        ? this.renderTable(logsList)
                                        : <div>This record has no logs yet.</div>}
                                </div>
                            </div>
                        </div>

                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                {this.state.showSavedMsg &&
                    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                        position={'top-center'}
                    />}

                <div className="row-wide">
                    <div className="col s12">
                        <h4 className="bar-bottom">Milestones</h4>
                    </div>
                </div>

                <div className="col s12 infra-checklist" >
                    <div className="table-y-scroll-hidden">
                        <table className="table-no-borders">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Applicable/Not applicable</th>
                                    <th>Date ordered</th>
                                    <th>Date Required</th>
                                    <th>Date Received/Achieved</th>
                                    <th>Comments</th>
                                    <th>Log</th>
                                </tr>
                            </thead>

                            <tbody>
                                {documentCheckList.map((item, index) =>
                                    <tr key={index}>                                        
                                        {item.lkp_DocumentChecklist.displayDropdown && item.lkp_DocumentChecklist.lkp_DocChecklistDropdownValues.length > 0
                                            ? <td><span id="chkListLbl">{item.lkp_DocumentChecklist.documentName}</span>
                                                <Select name='dropdownValueId'
                                                    value={item['dropdownValueId']}
                                                    options={this.getSelectOptions(item.lkp_DocumentChecklist.lkp_DocChecklistDropdownValues, 'description')}
                                                    onChange={this.handleSelectChangeDd(index, 'dropdownValueId')}
                                                /></td>
                                            : <td>{item.lkp_DocumentChecklist.documentName}</td>}                              
                                        <td>
                                            <Select name='applicableStatus'
                                                value={item['applicableStatus']}
                                                options={[{ label: 'Applicable', value: 'Applicable' },
                                                { label: 'Not applicable', value: 'Not applicable' }]}
                                                onChange={this.handleSelectChange(index, 'applicableStatus')}
                                            />
                                        </td>
                                        <td>
                                            {item['applicableStatus'] === 'Applicable' ?
                                            <div className="controls date-control">
                                                <DateFieldFixedDateBelow
                                                    name="submittedDate"
                                                    value={item['submittedDate']}
                                                    limits={{dateBelow: item['receivedDate']}}
                                                    onChange={this.handleDateChange(index, 'submittedDate')}
                                                />
                                            </div>
                                           : null }
                                        </td>

                                        <td> 
                                        {item['applicableStatus'] === 'Applicable' ?                                     
                                            <div className="controls date-control">
                                                <DateFieldFixedDateBelow
                                                    name="dateRequired"
                                                    value={item['dateRequired']}
                                                    limits={{}}
                                                    onChange={this.handleDateChange(index, 'dateRequired')}
                                                />
                                            </div>  
                                            : null }                                     
                                        </td>

                                        <td>
                                        {item['applicableStatus'] === 'Applicable' &&
                                            <div className="controls date-control">
                                                <DateFieldFixedDateBelow
                                                    name="receivedDate"
                                                    value={item['receivedDate']}
                                                    limits={{dateAbove: item['submittedDate']}}
                                                    onChange={this.handleDateChange(index, 'receivedDate')}
                                                />
                                            </div>
                                        }
                                        </td>

                                        <td>
                                            <div className="controls">
                                                <textarea name="comments"
                                                    value={item.comments || ''} onChange={this.handleChange(index, 'comments')}></textarea>
                                            </div>
                                        </td>
                                        <td>
                                            {(item.documentChkList_Log !== null && item.documentChkList_Log.some(c=>c.comments !== null || c.receivedDate !== null || c.submittedDate !== null) ) 
                                            ? <button className="btn-save margin-left-0" onClick={() => this.showLog(item)}>Log</button> : null}
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                            <button className="btn-save margin-left-175" onClick={this.handleSubmit} disabled={!canSubmit}> Save</button>
                            { isLoading ? <div className="loader loader-infra"/> :null }   

                        </table>
                    </div>                  

                </div>  

            </div>
        );
    }
}

InfraChecklist.propTypes = {
    documentCheckList: PropTypes.array.isRequired,
    permissions: PropTypes.object.isRequired,
    fetchDocumentChecklist: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        documentCheckList: state.additionalProjectsStore.documentCheckList,
        permissions: state.projectsStore.permissions,
    };
}

export default connect(mapStateToProps, {
    fetchDocumentChecklist,
})(InfraChecklist);